import React from 'react';
import DomainSubNavigator2 from "nood-comp/src/comp/ui/nav/DomainSubNavigator2";
import Orgs from "src/routes/orgs/orgs/Orgs";
import { msgs } from "nood-comp/src/locale/msgs";
import { msg } from "src/app/msg";
import PageTitle from "nood-comp/src/comp/ui/containers/PageTitle";
import OrgView from "src/routes/orgs/orgs/OrgView";
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
import { useDocumentTitle } from "usehooks-ts";
export default function Org(props) {
  useDocumentTitle(msg.title(msgs.many(msg.org)));
  var id = useURLParam('id');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageTitle, {
    title: msgs.many(msg.org)
  }), /*#__PURE__*/React.createElement(DomainSubNavigator2, {
    queryFilter: 'do',
    defaultHighlight: 'list',
    menuItems: [{
      id: "list",
      icon: "list",
      content: /*#__PURE__*/React.createElement(Orgs, null),
      label: msgs.many(msg.org),
      queryString: {
        id: undefined
      }
    }, {
      id: "view",
      icon: "eye",
      content: /*#__PURE__*/React.createElement(OrgView, null),
      label: msgs.view,
      show: id
    }]
  }));
}
Org.propTypes = {
  // proptypes
};
Org.defaultProps = {
  // default propTypes
};